import {
    HCP_DATA,
    FILTER_HCPDATA,
    HCP_SELECTION,
    NEW_HCP,
    EDIT_HCP,
    HCPS_COUNT,
    HCP_LOCKED_STATUS,

    CLINICS_DATA,
    FILTER_CLINICSDATA,
    CLINICS_SELECTION,
    NEW_CLINIC,
    EDIT_CLINIC,
    CLINICS_COUNT,
    DELETE_CLINIC_HCPS,
    DELETE_CLINIC,

    ADMINS_DATA,
    FILTER_ADMINSDATA,
    ADMINS_SELECTION,
    ADMIN_LOCKED_STATUS,
    NEW_ADMIN,
    EDIT_ADMIN,
    ADMINS_COUNT,
    DELETE_ADMIN,

    FILTER_REQUESTS_DATA,
    REQUESTS_DATA,
    REQUESTS_COUNT,
    EDIT_Request,
    EDIT_Payment,
    PATIENTS_DATA,
    FILTER_PATIENTSDATA,
    PATIENTS_SELECTION,
    EDIT_PATIENT,
    PATIENTS_COUNT,
    NEW_PATIENT,
    PATIENT_LOCKED_STATUS,
    DELETE_PATIENT,
    VERSIONS_DATA,
    FILTER_VERSIONSDATA,
    VERSIONS_SELECTION,
    NEW_VERSION,
    EDIT_VERSION,
    VERSIONS_COUNT,
    DELETE_VERSION,

    PATIENTS_STATUSES,
    CLEAN_HCP,
    CLEAN_CLINIC,
    CLEAN_ADMIN,
    CLEAN_PATIENT,
    CLEAN_VERSIONS,
    CLOSED_EDIT_Request,
    DELETE_MEDIATOR,
    CLOSED_EDIT_Payment,
    CLOSED_REQUESTS_COUNT,
    CLOSED_REQUESTS_DATA,
    CLOSED_FILTER_REQUESTS_DATA, MEDIATOR_DATA, EDIT_MEDIATOR, NEW_MEDIATOR,MEDIATORS_COUNT,MEDIATOR_LOCKED_STATUS

} from "../constants/Tabs-Action-Types";



//HCPS-table
export function editRequests(payload) {
    return {type: EDIT_Request, payload}
}
export function editPayment(payload) {
    return {type: EDIT_Payment, payload}
}
export function SETRequestsCount(payload) {
    return {type: REQUESTS_COUNT, payload}
}
export function setRequests(payload,statuses) {
    return { type: REQUESTS_DATA, payload,statuses};
}
export function filterRequestsTable(searchType,payload) {
    return {type: FILTER_REQUESTS_DATA,searchType, payload};
}
export function editClosedRequests(payload) {
    return {type: CLOSED_EDIT_Request, payload}
}
export function editClosedPayment(payload) {
    return {type: CLOSED_EDIT_Payment, payload}
}
export function SETClosedRequestsCount(payload) {
    return {type: CLOSED_REQUESTS_COUNT, payload}
}
export function setClosedRequests(payload,statuses) {
    return { type: CLOSED_REQUESTS_DATA, payload,statuses};
}
export function filterClosedRequestsTable(searchType,payload) {
    return {type: CLOSED_FILTER_REQUESTS_DATA,searchType, payload};
}
export function setHcpData(payload) {
    return { type: HCP_DATA, payload };
}
export function filterHcpTable(searchType, payload) {
    return { type: FILTER_HCPDATA, searchType, payload };
}
export function setHcpDataSelection(payload) {
    return { type: HCP_SELECTION, payload };
}
export function addNewHCP(payload) {
    return {type: NEW_HCP, payload}
}
export function editHCP(payload) {
    return {type: EDIT_HCP, payload}
}
export function SETHCPsCount(payload) {
    return {type: HCPS_COUNT, payload}
}
export function setHcpLockedStatus(payload) {
    return {type: HCP_LOCKED_STATUS, payload}
}
export function cleanHcp() {
    return {type: CLEAN_HCP}
}
//CLINICS-table
export function setClinicsData(payload) {
    return { type: CLINICS_DATA, payload };
}
export function filterClinicsTable(searchType, payload) {
    return { type: FILTER_CLINICSDATA, searchType, payload };
}
export function setClinicDataSelection(payload) {
    return { type: CLINICS_SELECTION, payload };
}
export function addNewClinic(payload) {
    return {type: NEW_CLINIC, payload}
}
export function editClinic(payload) {
    return {type: EDIT_CLINIC, payload}
}

export function deleteClinic(payload) {
    return {type: DELETE_CLINIC, payload}
}
export function SETClinicsCount(payload) {
    return {type: CLINICS_COUNT, payload}
}

export function deleteClinicHcps(siteId) {
    return {type: DELETE_CLINIC_HCPS, siteId}
}
export function cleanClinic() {
    return {type: CLEAN_CLINIC}
}
//ADMINS-table
export function setAdminsData(payload) {
    return { type: ADMINS_DATA, payload };
}
export function filterAdminsTable(searchType, payload) {
    return { type: FILTER_ADMINSDATA, searchType, payload };
}
export function setAdminDataSelection(payload) {
    return { type: ADMINS_SELECTION, payload };
}
export function addNewAdmin(payload) {
    return {type: NEW_ADMIN, payload}
}
export function editAdmin(payload) {
    return {type: EDIT_ADMIN, payload}
}
export function SETAdminCount(payload) {
    return {type: ADMINS_COUNT, payload}
}
export function deleteAdmin(payload) {
    return {type: DELETE_ADMIN, payload}
}
export function setAdminLockedStatus(payload) {
    return {type: ADMIN_LOCKED_STATUS, payload}
}
export function cleanAdmin() {
    return {type: CLEAN_ADMIN}
}
//PATIENTS-table
export function setPatientsData(payload) {
    return { type: PATIENTS_DATA, payload };
}
export function filterPatientsTable(searchType, payload) {
    return { type: FILTER_PATIENTSDATA, searchType, payload };
}
export function setPatientsDataSelection(payload) {
    return { type: PATIENTS_SELECTION, payload };
}
export function SETPatientsCount(payload) {
    return {type: PATIENTS_COUNT, payload}
}

export function addNewPatient(payload) {
    return {type: NEW_PATIENT, payload}
}
export function editPatientData(payload) {
    return {type: EDIT_PATIENT, payload}
}
export function setPatientLockedStatus(payload) {
    return {type: PATIENT_LOCKED_STATUS, payload}
}
export function deletePatient(payload) {
    return {type: DELETE_PATIENT, payload}
}
export function setPatientsStatuses(payload) {
    return { type: PATIENTS_STATUSES, payload };
}

export function cleanPatient() {
    return {type: CLEAN_PATIENT}
}



export function setMediatorData(payload) {
    return {type: MEDIATOR_DATA,payload}
}
export function editMediatorData(payload) {
    return {type: EDIT_MEDIATOR, payload}
}
export function setDeletedMediator(payload) {
    return {type: DELETE_MEDIATOR, payload}
}
export function addMediatorData(payload) {
    return {type: NEW_MEDIATOR,payload}
}
export function SetMediatorsCount(payload) {
    return {type: MEDIATORS_COUNT, payload}
}
export function SetMediatorsLock(payload) {
    return {type: MEDIATOR_LOCKED_STATUS, payload}
}
